import script from "./copy-text.vue?vue&type=script&lang=js"
export * from "./copy-text.vue?vue&type=script&lang=js"

import "./copy-text.vue?vue&type=style&index=0&id=95112f7e&lang=scss&scoped=true"

import exportComponent from "/Volumes/kaifa/ApiJavaAdmin/vn-admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95112f7e"]])

export default __exports__